import styled from '@emotion/styled'

import { getColor, SpacingSize, theme } from '../../Theme'

const defaultMargin = theme.spacing.sizes.smaller

/**
 * A divider that defaults to the theme's smaller spacing for top and bottom margins, but can be overridden with props.
 */
const Divider = styled.div<{
  marginBottom?: SpacingSize
  marginTop?: SpacingSize
}>`
  height: 1px;
  background-color: ${(p) => getColor(p.theme, ['grayLight'], ['grayDark'])};
  width: 100%;
  margin-bottom: ${(p) => (p.marginBottom ? theme.spacing.sizes[p.marginBottom] : defaultMargin)};
  margin-top: ${(p) => (p.marginTop ? theme.spacing.sizes[p.marginTop] : defaultMargin)};
`
export default Divider
